import './index.css';
import App from './App';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import { PrimeReactProvider } from 'primereact/api';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from './Services/Context-Api/ThemeContext';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "quill/dist/quill.snow.css";

const isDevToolsOpen =
    window.outerWidth - window.innerWidth > 160 ||
    window.outerHeight - window.innerHeight > 160;

const shouldBlock =''
    // process.env.REACT_APP_NODE_ENV == "production" && isDevToolsOpen;

if (shouldBlock) {
    window.fetch = () => Promise.reject();
    XMLHttpRequest.prototype.open = function () { };
    Object.defineProperty(window, "localStorage", {
        get() {
            return null;
        },
    });
    Object.defineProperty(window, "sessionStorage", {
        get() {
            return null;
        },
    });
    document.body.innerHTML = `
    <h1 class="body-overlay">
      DevTools is not allowed
    </h1>
  `;
} else {
    const container = document.getElementById('root');
    if (container) {
        const root = createRoot(container);
        root.render(
            <ThemeProvider>
                <PrimeReactProvider>
                    <App />
                </PrimeReactProvider>
            </ThemeProvider>
        );
    }
}